module.exports = __webpack_public_path__ + "img/rvk.7ad4aeb0.svg";